import { Editor } from '../core/Editor';
import { Icons } from './Icons';

export class TopMenu {
  private editor: Editor;
  private container: HTMLElement;

  constructor(editor: Editor, container: HTMLElement) {
    this.editor = editor;
    this.container = container;
    this.render();
  }

  public render() {
    this.container.innerHTML = `
      <div class="top-menu-bar">
        <!-- Logo / App Branding (Pirate-Themed Iron Crop) -->
        <div class="brand-group" title="Iron Crop — Pirate Edition (photo.drb.wang)">
          <div class="brand-logo">
            <svg width="28" height="28" viewBox="0 0 64 64" fill="none" class="pirate-brand-svg">
              <defs>
                <linearGradient id="ironPlateTop" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#334155" />
                  <stop offset="50%" stop-color="#1e293b" />
                  <stop offset="100%" stop-color="#0f172a" />
                </linearGradient>
                <linearGradient id="steelGleamTop" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#f8fafc" />
                  <stop offset="50%" stop-color="#cbd5e1" />
                  <stop offset="100%" stop-color="#64748b" />
                </linearGradient>
                <linearGradient id="pirateGoldTop" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stop-color="#fef08a" />
                  <stop offset="40%" stop-color="#f59e0b" />
                  <stop offset="100%" stop-color="#b45309" />
                </linearGradient>
              </defs>
              <!-- 1. Iron Base Plate with Rivets -->
              <rect width="64" height="64" rx="14" fill="url(#ironPlateTop)" />
              <rect x="2" y="2" width="60" height="60" rx="12" stroke="url(#steelGleamTop)" stroke-width="1.5" stroke-opacity="0.4" />
              <circle cx="6" cy="6" r="1.5" fill="#94a3b8" />
              <circle cx="58" cy="6" r="1.5" fill="#94a3b8" />
              <circle cx="6" cy="58" r="1.5" fill="#94a3b8" />
              <circle cx="58" cy="58" r="1.5" fill="#94a3b8" />
              <!-- 2. The 4 Crop Corner Brackets [  ] (Iron Crop) -->
              <g stroke="url(#pirateGoldTop)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M 8 16 L 8 9 L 15 9" />
                <path d="M 49 9 L 56 9 L 56 16" />
                <path d="M 8 48 L 8 55 L 15 55" />
                <path d="M 49 55 L 56 55 L 56 48" />
              </g>
              <!-- 3. Crossed Pirate Cutlasses (Swords) -->
              <path d="M 14 50 Q 28 36 48 16 Q 44 24 38 32 L 20 50 Z" fill="url(#steelGleamTop)" />
              <line x1="16" y1="46" x2="22" y2="52" stroke="url(#pirateGoldTop)" stroke-width="3" stroke-linecap="round" />
              <circle cx="13" cy="53" r="2" fill="url(#pirateGoldTop)" />
              <path d="M 50 50 Q 36 36 16 16 Q 20 24 26 32 L 44 50 Z" fill="url(#steelGleamTop)" />
              <line x1="48" y1="46" x2="42" y2="52" stroke="url(#pirateGoldTop)" stroke-width="3" stroke-linecap="round" />
              <circle cx="51" cy="53" r="2" fill="url(#pirateGoldTop)" />
              <!-- 4. Pirate Skull with Tricorn Hat & Eyepatch -->
              <path d="M 23 32 C 22 25, 42 25, 41 32 C 41 35.5, 39 37.5, 37.5 39 L 37.5 43.5 C 37.5 45, 35 46, 32 46 C 29 46, 26.5 45, 26.5 43.5 L 26.5 39 C 25 37.5, 23 35.5, 23 32 Z" fill="#f8fafc" stroke="#cbd5e1" stroke-width="1" />
              <path d="M 23 24 Q 32 15 41 24 Z" fill="#0f172a" stroke="url(#pirateGoldTop)" stroke-width="1" />
              <path d="M 15 25 Q 32 18 49 25 C 44 21, 38 21, 32 22 C 26 21, 20 21, 15 25 Z" fill="#1e293b" stroke="url(#pirateGoldTop)" stroke-width="1.2" />
              <circle cx="32" cy="20" r="2" fill="url(#pirateGoldTop)" />
              <!-- Eyepatch & details -->
              <path d="M 23 29 L 41 36" stroke="#0f172a" stroke-width="1.5" stroke-linecap="round" />
              <ellipse cx="28" cy="33.5" rx="2.5" ry="3" fill="#0f172a" />
              <ellipse cx="36" cy="34" rx="3.2" ry="3.5" fill="#0f172a" stroke="url(#pirateGoldTop)" stroke-width="0.8" />
              <path d="M 34.5 34 L 37.5 34 M 36 32.5 L 36 35.5" stroke="url(#pirateGoldTop)" stroke-width="0.7" />
              <path d="M 32 37.5 L 30.8 40 L 33.2 40 Z" fill="#0f172a" />
              <line x1="29" y1="42.5" x2="29" y2="45.5" stroke="#94a3b8" stroke-width="0.8" />
              <rect x="30.5" y="42.5" width="2.5" height="3" fill="url(#pirateGoldTop)" rx="0.5" />
              <line x1="35" y1="42.5" x2="35" y2="45.5" stroke="#94a3b8" stroke-width="0.8" />
            </svg>
          </div>
          <div class="brand-info">
            <span class="brand-title">Iron Crop</span>
            <span class="brand-domain">photo.drb.wang</span>
          </div>
        </div>

        <!-- Menu Dropdowns -->
        <div class="menu-items-group">
          <!-- File Menu -->
          <div class="menu-dropdown">
            <button class="menu-btn" id="m-file">File</button>
            <div class="dropdown-menu">
              <button class="dropdown-item highlight" id="item-start-new">
                <span>✨ Start New (Clear Session)</span>
                <kbd>Ctrl+Alt+N</kbd>
              </button>
              <button class="dropdown-item" id="item-new-canvas">
                <span>New Canvas...</span>
                <kbd>Ctrl+N</kbd>
              </button>
              <button class="dropdown-item" id="item-open-file">
                <span>Open Image File...</span>
                <kbd>Ctrl+O</kbd>
              </button>
              <button class="dropdown-item" id="item-import-layer">
                <span>Import Image as Layer...</span>
              </button>
              <button class="dropdown-item" id="item-close-doc">
                <span>Close Document</span>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-paste-clip">
                <span>Paste from Clipboard</span>
                <kbd>Ctrl+V</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-load-sneaker">
                <span>Sample: Cyber Sneaker</span>
              </button>
              <button class="dropdown-item" id="item-load-portrait">
                <span>Sample: Studio Portrait</span>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item highlight" id="item-save-web">
                <span>⚡ Save for Web & Optimize...</span>
                <kbd>Alt+Shift+S</kbd>
              </button>
              <div class="dropdown-submenu-parent">
                <span class="dropdown-item">
                  <span>Export Image As &rarr;</span>
                </span>
                <div class="dropdown-submenu">
                  <button class="dropdown-item" id="exp-png">PNG (Lossless & Alpha)</button>
                  <button class="dropdown-item" id="exp-jpg">JPEG / JPG</button>
                  <button class="dropdown-item" id="exp-webp">WebP (Modern)</button>
                  <button class="dropdown-item" id="exp-avif">AVIF (High Efficiency)</button>
                  <button class="dropdown-item" id="exp-svg">SVG Container</button>
                  <button class="dropdown-item" id="exp-ico">Favicon (.ICO)</button>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-save-proj">
                <span>Save Project (.photodrb)</span>
              </button>
              <button class="dropdown-item" id="item-open-proj">
                <span>Open Project (.photodrb)</span>
              </button>
            </div>
          </div>

          <!-- Edit Menu -->
          <div class="menu-dropdown">
            <button class="menu-btn" id="m-edit">Edit</button>
            <div class="dropdown-menu">
              <button class="dropdown-item" id="item-undo">
                <span>Undo</span>
                <kbd>Ctrl+Z</kbd>
              </button>
              <button class="dropdown-item" id="item-redo">
                <span>Redo</span>
                <kbd>Ctrl+Y</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-cut">
                <span>Cut</span>
                <kbd>Ctrl+X</kbd>
              </button>
              <button class="dropdown-item" id="item-copy">
                <span>Copy</span>
                <kbd>Ctrl+C</kbd>
              </button>
              <button class="dropdown-item" id="item-paste">
                <span>Paste</span>
                <kbd>Ctrl+V</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-fill-fg">
                <span>Fill Foreground Color</span>
                <kbd>Alt+Bksp</kbd>
              </button>
              <button class="dropdown-item" id="item-fill-bg">
                <span>Fill Background Color</span>
                <kbd>Ctrl+Bksp</kbd>
              </button>
              <button class="dropdown-item" id="item-transform">
                <span>Free Transform</span>
                <kbd>Ctrl+T</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-sel-all">
                <span>Select All</span>
                <kbd>Ctrl+A</kbd>
              </button>
              <button class="dropdown-item" id="item-desel">
                <span>Deselect</span>
                <kbd>Ctrl+D</kbd>
              </button>
              <button class="dropdown-item" id="item-inv-sel">
                <span>Invert Selection</span>
                <kbd>Ctrl+Shift+I</kbd>
              </button>
              <button class="dropdown-item" id="item-del-sel">
                <span>Clear Selection</span>
                <kbd>Del</kbd>
              </button>
            </div>
          </div>

          <!-- Image Menu -->
          <div class="menu-dropdown">
            <button class="menu-btn" id="m-image">Image</button>
            <div class="dropdown-menu">
              <button class="dropdown-item" id="item-img-adjust">
                <span>Adjustments & Color...</span>
                <kbd>Ctrl+U</kbd>
              </button>
              <button class="dropdown-item highlight" id="item-auto-bg">
                <span>🚀 1-Click Remove Background</span>
              </button>
              <button class="dropdown-item" id="item-inv-color">
                <span>Invert Colors</span>
                <kbd>Ctrl+I</kbd>
              </button>
              <button class="dropdown-item" id="item-desaturate">
                <span>Desaturate</span>
                <kbd>Ctrl+Shift+U</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item highlight" id="item-crop-sel">
                <span>Crop to Selection</span>
                <kbd>Alt+I+P</kbd>
              </button>
              <button class="dropdown-item highlight" id="item-trim-borders">
                <span>Trim Transparent Borders</span>
                <kbd>Alt+Shift+T</kbd>
              </button>
              <button class="dropdown-item highlight" id="item-open-overlay-studio">
                <span>🎞️ Photo Overlay Border & 7s Reel...</span>
                <kbd>Alt+Shift+B</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-flip-h">
                <span>Flip Horizontal</span>
              </button>
              <button class="dropdown-item" id="item-flip-v">
                <span>Flip Vertical</span>
              </button>
              <button class="dropdown-item" id="item-rot-cw">
                <span>Rotate 90° Clockwise</span>
              </button>
              <button class="dropdown-item" id="item-rot-ccw">
                <span>Rotate 90° Counter-Clockwise</span>
              </button>
            </div>
          </div>

          <!-- Layer Menu -->
          <div class="menu-dropdown">
            <button class="menu-btn" id="m-layer">Layer</button>
            <div class="dropdown-menu">
              <button class="dropdown-item" id="item-new-layer">
                <span>New Layer</span>
                <kbd>Ctrl+Shift+N</kbd>
              </button>
              <button class="dropdown-item" id="item-dup-layer">
                <span>Duplicate Layer</span>
                <kbd>Ctrl+J</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-merge-down">
                <span>Merge Down</span>
                <kbd>Ctrl+E</kbd>
              </button>
              <button class="dropdown-item" id="item-flatten">
                <span>Flatten Image</span>
                <kbd>Ctrl+Shift+E</kbd>
              </button>
            </div>
          </div>

          <!-- Help Menu -->
          <div class="menu-dropdown">
            <button class="menu-btn" id="m-help">Help</button>
            <div class="dropdown-menu">
              <button class="dropdown-item highlight" id="item-shortcuts">
                <span>⌨️ Keyboard Shortcuts</span>
                <kbd>?</kbd>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" id="item-about">
                <span>About Iron Crop</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Locked Canvas Size Badge -->
        <div class="top-canvas-lock-badge" id="top-canvas-lock-badge" style="display: none;" title="Canvas background size is locked. Dragged photos will fit as layers without resizing the canvas.">
          <span class="badge-lock-icon">🔒</span>
          <span class="badge-lock-dim" id="top-lock-dim-text">1080 × 1920 px</span>
          <span class="badge-lock-tag">Locked</span>
        </div>

        <!-- Quick Action Buttons on right side of top bar -->
        <div class="quick-actions-group">
          <!-- Start New Button (Clears local storage and starts fresh) -->
          <button class="quick-btn start-new-btn highlight" id="qbtn-start-new" title="Start New (Clears project from local storage and starts fresh)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            <span>Start New</span>
          </button>

          <!-- Open Photo Quick Button -->
          <button class="quick-btn" id="qbtn-open" title="Open Photo (Ctrl+O) - Canvas size matches image">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
            </svg>
            <span>Open</span>
          </button>

          <!-- New Canvas Quick Button -->
          <button class="quick-btn" id="qbtn-new" title="New Canvas (Ctrl+N)">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>New</span>
          </button>

          <!-- Photo Overlay & 7s Reel Studio -->
          <button class="quick-btn special overlay-special-btn" id="qbtn-overlay-studio" title="Create Photo Overlay Border & 7s Audio Reel Package (Alt+Shift+B)">
            <span>🎞️ Reels & Overlay</span>
          </button>

          <!-- Shortcuts Quick Button -->
          <button class="quick-btn" id="qbtn-shortcuts" title="Photoshop Keyboard Shortcuts (? or F1)">
            <span>⌨️ Shortcuts</span>
          </button>

          <!-- 1-Click Remove BG -->
          <button class="quick-btn special" id="qbtn-remove-bg" title="1-Click Auto Background Remover">
            ${Icons.sparkles}
            <span>Remove BG</span>
          </button>

          <!-- Save for Web -->
          <button class="quick-btn optimize" id="qbtn-save-web" title="Save for Web (Reduce File Size)">
            <span>⚡ Save for Web</span>
          </button>

          <!-- Export dropdown button -->
          <div class="quick-export-container">
            <button class="quick-btn primary" id="qbtn-export-direct">
              ${Icons.download}
              <span>Export</span>
            </button>
            <button class="quick-btn primary-caret" id="qbtn-export-menu-toggle">
              ▾
            </button>
            <div class="quick-export-menu" id="quick-export-menu">
              <button class="quick-export-item" data-fmt="png">Download PNG (Lossless)</button>
              <button class="quick-export-item" data-fmt="jpeg">Download JPEG</button>
              <button class="quick-export-item" data-fmt="webp">Download WebP</button>
              <button class="quick-export-item" data-fmt="avif">Download AVIF</button>
              <button class="quick-export-item" data-fmt="svg">Download SVG</button>
              <button class="quick-export-item" data-fmt="ico">Download Favicon (.ICO)</button>
            </div>
          </div>
        </div>
      </div>
    `;

    this.attachEvents();
  }

  private attachEvents() {
    // Listen for canvas document state changes to show locked size
    this.editor.onDocumentStateChange = (hasDoc, w, h, locked) => {
      const lockBadge = this.container.querySelector('#top-canvas-lock-badge') as HTMLElement;
      const dimText = this.container.querySelector('#top-lock-dim-text');
      if (lockBadge && dimText) {
        if (hasDoc && locked) {
          lockBadge.style.display = 'inline-flex';
          dimText.textContent = `${w} × ${h} px`;
        } else {
          lockBadge.style.display = 'none';
        }
      }
    };

    // Hidden file input for Open Document (canvas size matches photo)
    const fileInputOpen = document.createElement('input');
    fileInputOpen.type = 'file';
    fileInputOpen.accept = 'image/*,.photodrb';
    fileInputOpen.style.display = 'none';
    document.body.appendChild(fileInputOpen);

    fileInputOpen.addEventListener('change', () => {
      const file = fileInputOpen.files?.[0];
      if (file) {
        if (file.name.endsWith('.photodrb')) {
          this.editor.loadProjectFromFile(file);
        } else {
          if (this.editor.hasDocument && this.editor.isBackgroundSizeLocked) {
            const replace = confirm(
              `Canvas background size is currently locked to ${this.editor.width} × ${this.editor.height} px.\n\n` +
              `• Click "OK" to start a NEW canvas matching this photo's dimensions.\n` +
              `• Click "Cancel" to place it as a LAYER keeping the locked ${this.editor.width} × ${this.editor.height} px canvas.`
            );
            if (replace) {
              this.editor.openImageFile(file);
            } else {
              this.editor.importImageAsLayer(file, { fitToCanvas: true });
            }
          } else {
            this.editor.openImageFile(file);
          }
        }
      }
      fileInputOpen.value = '';
    });

    // Hidden file input for Import as Layer
    const fileInputLayer = document.createElement('input');
    fileInputLayer.type = 'file';
    fileInputLayer.accept = 'image/*';
    fileInputLayer.style.display = 'none';
    document.body.appendChild(fileInputLayer);

    fileInputLayer.addEventListener('change', () => {
      const file = fileInputLayer.files?.[0];
      if (file) {
        this.editor.importImageAsLayer(file);
      }
      fileInputLayer.value = '';
    });

    // Quick top bar buttons
    this.container.querySelector('#qbtn-start-new')?.addEventListener('click', () => {
      this.editor.startNew(true);
    });

    this.container.querySelector('#item-start-new')?.addEventListener('click', () => {
      this.editor.startNew(true);
    });

    this.container.querySelector('#qbtn-open')?.addEventListener('click', () => {
      fileInputOpen.click();
    });

    this.container.querySelector('#qbtn-new')?.addEventListener('click', () => {
      this.editor.openNewCanvasModal();
    });

    this.container.querySelector('#qbtn-overlay-studio')?.addEventListener('click', () => {
      this.editor.openOverlayStudioModal();
    });

    this.container.querySelector('#item-open-overlay-studio')?.addEventListener('click', () => {
      this.editor.openOverlayStudioModal();
    });

    // File menu
    this.container.querySelector('#item-new-canvas')?.addEventListener('click', () => {
      this.editor.openNewCanvasModal();
    });

    this.container.querySelector('#item-open-file')?.addEventListener('click', () => {
      fileInputOpen.click();
    });

    this.container.querySelector('#item-import-layer')?.addEventListener('click', () => {
      fileInputLayer.click();
    });

    this.container.querySelector('#item-close-doc')?.addEventListener('click', () => {
      this.editor.closeDocument();
    });

    this.container.querySelector('#item-paste-clip')?.addEventListener('click', () => {
      this.editor.pasteFromClipboard();
    });

    this.container.querySelector('#item-load-sneaker')?.addEventListener('click', () => {
      this.editor.openSampleImage('/sample-product.jpg', 'Cyber Sneaker');
    });

    this.container.querySelector('#item-load-portrait')?.addEventListener('click', () => {
      this.editor.openSampleImage('/sample-portrait.jpg', 'Studio Portrait');
    });

    this.container.querySelector('#item-save-web')?.addEventListener('click', () => {
      this.editor.openSaveForWebModal();
    });

    this.container.querySelector('#item-save-proj')?.addEventListener('click', () => {
      this.editor.saveProject();
    });

    this.container.querySelector('#item-open-proj')?.addEventListener('click', () => {
      fileInput.click();
    });

    // Export formats
    const bindExport = (id: string, fmt: any) => {
      this.container.querySelector(`#${id}`)?.addEventListener('click', () => {
        this.editor.exportImage(fmt);
      });
    };
    bindExport('exp-png', 'png');
    bindExport('exp-jpg', 'jpeg');
    bindExport('exp-webp', 'webp');
    bindExport('exp-avif', 'avif');
    bindExport('exp-svg', 'svg');
    bindExport('exp-ico', 'ico');

    // Edit menu
    this.container.querySelector('#item-undo')?.addEventListener('click', () => this.editor.undo());
    this.container.querySelector('#item-redo')?.addEventListener('click', () => this.editor.redo());
    this.container.querySelector('#item-cut')?.addEventListener('click', () => this.editor.cutSelectionOrLayer());
    this.container.querySelector('#item-copy')?.addEventListener('click', () => this.editor.copySelectionOrLayer());
    this.container.querySelector('#item-paste')?.addEventListener('click', () => this.editor.pasteClipboard());
    this.container.querySelector('#item-fill-fg')?.addEventListener('click', () => this.editor.fillForeground());
    this.container.querySelector('#item-fill-bg')?.addEventListener('click', () => this.editor.fillBackground());
    this.container.querySelector('#item-transform')?.addEventListener('click', () => {
      this.editor.setTool('move');
      this.editor.showToast('Free Transform (Ctrl+T)');
    });
    this.container.querySelector('#item-sel-all')?.addEventListener('click', () => {
      this.editor.selection.selectAll(this.editor.width, this.editor.height);
      this.editor.render();
    });
    this.container.querySelector('#item-desel')?.addEventListener('click', () => {
      this.editor.selection.deselect();
      this.editor.render();
    });
    this.container.querySelector('#item-inv-sel')?.addEventListener('click', () => {
      this.editor.selection.invert(this.editor.width, this.editor.height);
      this.editor.render();
    });
    this.container.querySelector('#item-del-sel')?.addEventListener('click', () => {
      const l = this.editor.getActiveLayer();
      if (l) {
        this.editor.selection.clearSelection(l);
        this.editor.recordHistory('Clear Selection');
        this.editor.render();
      }
    });

    // Image menu
    this.container.querySelector('#item-img-adjust')?.addEventListener('click', () => {
      this.editor.openAdjustmentsModal();
    });
    this.container.querySelector('#item-auto-bg')?.addEventListener('click', () => {
      this.editor.autoRemoveBackground();
    });
    this.container.querySelector('#item-inv-color')?.addEventListener('click', () => {
      this.editor.invertActiveLayer();
    });
    this.container.querySelector('#item-desaturate')?.addEventListener('click', () => {
      this.editor.desaturateActiveLayer();
    });
    this.container.querySelector('#item-crop-sel')?.addEventListener('click', () => {
      this.editor.cropToSelection();
    });
    this.container.querySelector('#item-trim-borders')?.addEventListener('click', () => {
      this.editor.trimTransparentBorders();
    });
    this.container.querySelector('#item-flip-h')?.addEventListener('click', () => this.editor.flipHorizontal());
    this.container.querySelector('#item-flip-v')?.addEventListener('click', () => this.editor.flipVertical());
    this.container.querySelector('#item-rot-cw')?.addEventListener('click', () => this.editor.rotate90(true));
    this.container.querySelector('#item-rot-ccw')?.addEventListener('click', () => this.editor.rotate90(false));

    // Layer menu
    this.container.querySelector('#item-new-layer')?.addEventListener('click', () => {
      this.editor.addNewLayer();
    });
    this.container.querySelector('#item-dup-layer')?.addEventListener('click', () => {
      this.editor.duplicateLayerOrSelection();
    });
    this.container.querySelector('#item-merge-down')?.addEventListener('click', () => {
      this.editor.mergeDown();
    });
    this.container.querySelector('#item-flatten')?.addEventListener('click', () => {
      this.editor.flattenImage();
    });

    // Help menu & Shortcuts buttons
    this.container.querySelector('#item-shortcuts')?.addEventListener('click', () => {
      this.editor.openShortcutsModal();
    });
    this.container.querySelector('#item-about')?.addEventListener('click', () => {
      this.editor.openShortcutsModal();
    });
    this.container.querySelector('#qbtn-shortcuts')?.addEventListener('click', () => {
      this.editor.openShortcutsModal();
    });

    // Quick action buttons
    this.container.querySelector('#qbtn-remove-bg')?.addEventListener('click', () => {
      this.editor.autoRemoveBackground();
    });

    this.container.querySelector('#qbtn-save-web')?.addEventListener('click', () => {
      this.editor.openSaveForWebModal();
    });

    this.container.querySelector('#qbtn-export-direct')?.addEventListener('click', () => {
      this.editor.exportImage('png');
    });

    const exportMenuToggle = this.container.querySelector('#qbtn-export-menu-toggle');
    const exportMenu = this.container.querySelector('#quick-export-menu') as HTMLElement;
    exportMenuToggle?.addEventListener('click', (e) => {
      e.stopPropagation();
      exportMenu.classList.toggle('visible');
    });

    document.addEventListener('click', () => {
      if (exportMenu) exportMenu.classList.remove('visible');
    });

    this.container.querySelectorAll('.quick-export-item').forEach(item => {
      item.addEventListener('click', (e) => {
        const fmt = (e.currentTarget as HTMLElement).dataset.fmt as any;
        this.editor.exportImage(fmt);
        if (exportMenu) exportMenu.classList.remove('visible');
      });
    });
  }
}
